import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";

// function CustomerAdd(props, ref) {
const DashboardPublic = () => {
  return <>Public Dashboard</>;
};

export default DashboardPublic;
